import React, {Component} from "react"
import Button from "components/Button/Button"
import styled, {css} from "styled-components"
import {media} from "utils/Media"
import arrowIcon from 'images/white-arrow.svg'
const scrollToElement = require('scroll-to-element');

const ScrollButtonWrapper = styled.div`
    position: absolute;
    z-index: 19;
    left: 50%;
    transform: translateX(-50%);
    transition: opacity 0.2s ease-in;
    bottom: 80px;
    
    &.playBtn {
        bottom: 150px;
    }
    
    @media ${media.sm} {
        bottom: 90px;
    }
    
    &.hidden {
        opacity: 0;
    }
    
    &.story {
        bottom: 20px;
    }
`

const ButtonBkGround = styled.div`
    padding: .5rem 1rem;
    margin: 0;
    text-decoration: none;
    color: ${props => props.theme.colors.white};
    display: inline-block;
    font-size: 1rem;

    @media (min-width: 992px) {
        font-size: 1.25rem;
        padding: 1rem 3rem;
    }
`

const Arrow = styled.img`
    width: 51px;
    height: 28px;
`


class ScrollButton extends Component {
    render() {
        return (
            <ScrollButtonWrapper className={`${this.props.progress > 0.9 && 'hidden'} ${this.props.story && 'story'} ${this.props.playBtn && 'playBtn'}`}>
                <ButtonBkGround>
                    <Button >
                        <strong>scroll to reveal</strong><br/>
                        <Arrow className="down-arrow bounceUpAndDown" src={arrowIcon} alt="Arrow Down" />
                    </Button>
                </ButtonBkGround>
            </ScrollButtonWrapper>
        )
    }
}

export default ScrollButton